export default __webpack_public_path__ + "static/media/schedule.d065175d.png";